module.exports = __webpack_public_path__ + "img/Groupe 520.8382f50a.svg";